// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core--summary-line{display:flex;gap:10px}`, "",{"version":3,"sources":["webpack://./../ZaddonsJSLibs/common-client2/src/components/v1/SummaryLine/SummaryLine.scss"],"names":[],"mappings":"AAAA,oBACI,YAAA,CACA,QAAA","sourcesContent":[".core--summary-line {\r\n    display: flex;\r\n    gap: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
